<template>
  <w-icon-wrapper
    icon-name="work-organisation-element-icon"
    viewBox="0 0 22 23.75"
  >
    <g
      id="Ebene_2"
      data-name="Ebene 2"
    >
      <g
        id="Ebene_5"
        data-name="Ebene 5"
      >
        <polygon
          fill="currentColor"
          class="cls-1"
          points="20 0 20 17.88 2 17.88 2 0 0 0 0 23.75 2 23.75 2 19.88 20 19.88 20 23.75 22 23.75 22 0 20 0"
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconOrganisationElement' };
</script>
